<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('profile.profileparameter.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.bracket"
            :error-messages="bracketErrors"
            :label="$t('profile.profileparameter.bracket')"
            required
            @input="$v.item.bracket.$touch()"
            @blur="$v.item.bracket.$touch()"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.Unit"
            :error-messages="UnitErrors"
            :label="$t('profile.profileparameter.unit')"
            required
            @input="$v.item.Unit.$touch()"
            @blur="$v.item.Unit.$touch()"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.tab"
            :error-messages="tabErrors"
            :label="$t('profile.profileparameter.tab')"
            required
            @input="$v.item.tab.$touch()"
            @blur="$v.item.tab.$touch()"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.section0"
            :error-messages="section0Errors"
            :label="$t('profile.profileparameter.section0')"
            required
            @input="$v.item.section0.$touch()"
            @blur="$v.item.section0.$touch()"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.section1"
            :error-messages="section1Errors"
            :label="$t('profile.profileparameter.section1')"
            required
            @input="$v.item.section1.$touch()"
            @blur="$v.item.section1.$touch()"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="softwareVersionSelectItems"
            v-model="item.softwareVersion"
            :items="softwareVersionSelectItems"
            :error-messages="softwareVersionErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.profileparameter.softwareversion')"
            item-text="name"
            item-value="@id"
          />
        </v-col>

        <v-col cols="12"></v-col>
      </v-row>

    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';

export default {
  name: 'ProfileParameterForm',
  mixins: [validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.softwareVersionGetSelectItems();
  },
  data() {
    return {
        name: null,
        bracket: null,
        Unit: null,
        tab: null,
        section0: null,
        section1: null,
        softwareVersion: null,
    };
  },
  computed: {
      isLoading() {
        return (this.isLoading_softwareversion 
         );
      },
      ...mapFields('softwareversion', {
        softwareVersionSelectItems: 'selectItems',
        isLoading_softwareversion : 'isLoading'
      }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    nameErrors() {
      const errors = [];

      if (!this.$v.item.name.$dirty) return errors;

      has(this.violations, 'name') && errors.push(this.violations.name);

      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    bracketErrors() {
      const errors = [];

      if (!this.$v.item.bracket.$dirty) return errors;

      has(this.violations, 'bracket') && errors.push(this.violations.bracket);

      !this.$v.item.bracket.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    UnitErrors() {
      const errors = [];

      if (!this.$v.item.Unit.$dirty) return errors;

      has(this.violations, 'Unit') && errors.push(this.violations.Unit);

      !this.$v.item.Unit.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    tabErrors() {
      const errors = [];

      if (!this.$v.item.tab.$dirty) return errors;

      has(this.violations, 'tab') && errors.push(this.violations.tab);

      !this.$v.item.tab.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    section0Errors() {
      const errors = [];

      if (!this.$v.item.section0.$dirty) return errors;

      has(this.violations, 'section0') && errors.push(this.violations.section0);

      !this.$v.item.section0.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    section1Errors() {
      const errors = [];

      if (!this.$v.item.section1.$dirty) return errors;

      has(this.violations, 'section1') && errors.push(this.violations.section1);

      !this.$v.item.section1.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    softwareVersionErrors() {
      const errors = [];

      if (!this.$v.item.softwareVersion.$dirty) return errors;

      has(this.violations, 'softwareVersion') && errors.push(this.violations.softwareVersion);


      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        softwareVersionGetSelectItems: 'softwareversion/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      name: {
        required,
      },
      bracket: {
        required,
      },
      Unit: {
        required,
      },
      tab: {
        required,
      },
      section0: {
        required,
      },
      section1: {
        required,
      },
      softwareVersion: {
      },
    }
  }
};
</script>
